import { useCallback } from 'react';
import { useHref } from 'react-router-dom';

export function useLeadDetailHref() {
	const leadsHref = useHref('/leads');
	return useCallback(
		(leadId: string) => `${leadsHref}?id=${encodeURIComponent(leadId)}`,
		[leadsHref]
	);
}
